<!-- <div class="card" *ngIf="list">
        <div class="card-body p-0 border-radius-05" data-parent='#example'>
            <div class="d-flex p-1 pl-4 pr-4 stripe" [ngClass]="productInfo.headerColor">
                <div class="strong text-white">{{productInfo.shortDescription}}</div>
                <div class="d-flex ml-auto">
                    <div class="strong text-white mr-4">Batch ID</div>
                    <div class="strong text-white mr-4">Creation date</div>
                </div>
            </div>
            <div class="card-title">
                <div class="d-flex justify-content-between mt-2 ml-4 pb-0">
                    <div class="fs-24 strong pb-4">
                        <div class="h5 mb-0 fw-bold">{{productInfo.name}}</div>

                        <div class="h5 mb-0 text-secondary">{{port.name}}</div>
                    </div>
                    <div class=" d-flex pb-0">
                        <div class="visible-xs ">
                            <div class="small text-secondary">Listing Price</div>
                            <div class="strong"> 70000 </div>
                        </div>
                        <div class="visible-xs ml-5">
                            <div class="small text-secondary">In Negotiation</div>
                            <div class="strong"> 70000 </div>
                        </div>
                        <div class="visible-xs ml-5">
                            <div class="small text-secondary">Initial Stock</div>
                            <div class="strong"> 70000 </div>
                        </div>
                        <div class="visible-xs ml-5">
                            <div class="small text-secondary">Stock Sold</div>
                            <div class="strong"> 70000 </div>
                        </div>
                        <div class="visible-xs ml-5">
                            <div class="small text-secondary">Collected</div>
                            <div class="strong"> 70000 </div>
                        </div>
                        <div class="visible-xs ml-5">
                            <div class="small text-secondary">To pick up</div>
                            <div class="strong"> 70000 </div>
                        </div>
                        <div class="visible-xs ml-5 mr-5">
                            <div class="small text-secondary">Tradable Balance</div>
                            <div class="strong"> 70000 </div>
                        </div>
                    </div>

                </div>
                <div class="hr"></div>
                <div class="inside-layout  align-self-stretch">
                    <div class="viewdetails hidden-xs ">
                        <a class="strong  btn btn-link">
              {{ 'home.quote.Viewdetails' | cxTranslate }} ></a>
                    </div>
                </div>
            </div>

        </div>
    
 </div> -->

<!--Experiment-->
<div *ngIf="publishedData.length === 0" class="text-center strong  text-primary mb-5">No results</div>
<div *ngIf="list && !width">
    <div class="card" *ngFor="let publishedData of publishedData; let i=index">
        <div class="card-body p-0 border-radius-05" data-parent='#example'>
            <div class="d-flex p-1 pl-4 pr-3 stripe" [ngStyle]="{'background-color':publishedData.headerColor}">
                <!-- <div class=" text-white">{{publishedData.shortDescription ? publishedData.shortDescription : publishedData.baseProductCode}}</div> -->
                <div class=" text-white">{{publishedData && publishedData.baseProductCode}}</div>
                <div class="d-flex ml-auto">
                    <div class=" text-white mr-4" *ngIf="publishedData && publishedData.vesselName">Vessel Name: {{publishedData.vesselName}}</div>
                    <div class=" text-white mr-4">Batch ID: {{publishedData.batchId}}</div>
                    <div class=" text-white">Creation Date: {{publishedData.creationDate| date: 'yyyy/MM/dd'}}</div>
                </div>
            </div>
            <div class="card-title">
                <div class="d-flex justify-content-between mt-2 ml-4 pb-2 pt-4">
                    <div class="fs-24 strong">
                        <div class="h5 mb-0 fw-bold">{{publishedData.name ? publishedData.name : publishedData.baseProduct}}</div>
    
                        <!-- <div class="h6 mb-0 text-secondary">{{port.name}}</div> -->
                        <div class="h6 mb-0 text-secondary">{{publishedData.portName}}</div>
                    </div>
                    <div class=" d-flex pb-0">
                        <div class="visible-xs ">
                            <div class="small text-secondary">Listing Price</div>
                            <div class="strong"> {{publishedData && publishedData.price && publishedData.price.formattedValue || '0'}} </div>
                        </div>
                        <div class="visible-xs ml-5">
                            <div class="small text-secondary">In Negotiation</div>
                            <div class="strong"> {{publishedData && publishedData.stockMetrics && publishedData.stockMetrics.negotiationQty || '0' | number :"1.0"}} </div>
                        </div>
                        <div class="visible-xs ml-5">
                            <div class="small text-secondary">Available Stock</div>
                            <div class="strong"> {{publishedData && publishedData.stockMetrics && publishedData.stockMetrics.availableQty || '0' | number :"1.0"}} </div>
                        </div>
                        <div class="visible-xs ml-5">
                            <div class="small text-secondary">Stock Issued</div>
                            <div class="strong"> {{publishedData && publishedData.stockMetrics && publishedData.stockMetrics.stockIssued || '0' | number :"1.0"}} </div>
                        </div>
                        <div class="visible-xs ml-5">
                            <div class="small text-secondary">Stock Sold</div>
                            <div class="strong"> {{publishedData && publishedData.stockMetrics && publishedData.stockMetrics.soldQty || '0' | number :"1.0"}} </div>
                        </div>
                        <div class="visible-xs ml-5">
                            <div class="small text-secondary">Collected</div>
                            <div class="strong"> {{publishedData && publishedData.stockMetrics && publishedData.stockMetrics.collectedQty || '0'| number :"1.0"}} </div>
                        </div>
                        <div class="visible-xs ml-5">
                            <div class="small text-secondary">To Pick Up</div>
                            <div class="strong"> {{publishedData && publishedData.stockMetrics && publishedData.stockMetrics.toPickUp || '0' | number :"1.0"}} </div>
                        </div>
                        <div class="visible-xs ml-5 mr-5">
                            <div class="small text-secondary">Tradable Balance</div>
                            <div class="strong"> {{publishedData && publishedData.stockMetrics && publishedData.stockMetrics.balanceQty || '0' | number :"1.0"}} </div>
                        </div>
                    </div>
    
                </div>
                <div class="hr"></div>
                <div class="d-flex  align-self-stretch">
                    <div class="viewdetails hidden-xs ">
                        <a class="strong  btn btn-link" (click)="gotoDeatils(publishedData.code)">
                            View details  ></a>
                    </div>
                    <div class="d-flex ml-auto justify-content-between p-1">
                        <div class="small text-secondary  mr-4">Bids & offers:</div>
                        <div class="strong  mr-4" [ngClass]="{'bg-yellow': publishedData && publishedData.bids_offers && publishedData.bids_offers.negotiation && publishedData.bids_offers.negotiation > 0}">{{publishedData.bids_offers.negotiation}} in Negotiation</div>
                        <div class="strong  mr-4">{{publishedData.bids_offers.accepted}} Accepted</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--End-->
<div class="grid-all mt-4" *ngIf="grid || width">
    <div class="card-grid mr-4" *ngFor="let publishedData of publishedData; let i=index">
        <div class="card-header stripe d-flex pt-1 pb-1 pl-2 pr-2" [ngStyle]="{'background-color':publishedData.headerColor}">
           <!-- <div class="small strong ml-1 mr-2">{{publishedData.shortDescription}}</div> -->
           <div class="small strong ml-1 mr-2">{{publishedData.baseProductCode}}</div>
           <div class="small strong  ml-auto pe-auto mr-2 text-truncate w-50">Batch ID: {{publishedData.code}}</div>
        </div>
       <div class="card-body-grid">
           <div class="card-title-grid mb-4">
               <span class="line-clamp h5 strong overflow-hidden">{{publishedData.name ? publishedData.name : publishedData.baseProduct}}</span>
               <div class="text-secondary line-clamp-single mt-1 h5">
                {{publishedData.portName}}
               </div>
           </div>
           <div class="d-flex justify-content-between min-h-4 text-secondary">
               <div class="width-48 small">
                   <div>Listing Price</div>
                   <div class="strong">{{publishedData.price.formattedValue}}</div>
               </div>
               <div class="width-48 small">
                   <div>In Negotiation</div>
                   <div class="strong">{{publishedData.stockMetrics.negotiationQty | number :"1.0"}}</div>
               </div>
           </div>
           <div class="hr"></div>
           <div class="inside-layout  align-self-stretch">
               <div class="viewdetails hidden-xs mb-4">
                   <a class="strong  btn btn-link pl-0" (click)="gotoDeatils(publishedData.code)">
                    View details  ></a>
               </div>
           </div>
       </div>
    </div>
</div>
 